export const convertFloatToPercentageString = (value: number | string) => {
  const countNumbersAfterDot = Number(value).toString().split('.')[1]?.length || 0

  return parseFloat(Number(Number(value) * 100).toFixed(countNumbersAfterDot))
}